module.exports = __webpack_public_path__ + "img/safari-modal-icon.75f205ff.svg";